import { FC } from "react";
import PdfViewer from "@/components/pdf-viewer/PdfViewer";

const ManifestoPage: FC = () => {
  return <PdfViewer pdfPath="/assets/manifesto.pdf" title="CULT DAO Manifesto" />;
};

export default ManifestoPage;
